import React, { FC } from 'react'
import { Tag } from 'rsuite'
import useTranslation from 'next-translate/useTranslation'

import { Product } from '../../utils/types/Product'
import { shouldShowBestSellerTag } from './utils/bestSellerAlgorithm'

import tagStyles from '../../styles/Tag.module.less'
import styles from '../../styles/BestSellerTag.module.less'

interface BestSellerTagProps {
  product: Product
  className?: string
  showIcon?: boolean
  customText?: string
}

const BestSellerTag: FC<BestSellerTagProps> = (props) => {
  const {
    product,
    className = '',
    customText,
  } = props

  const { t } = useTranslation('products')

  const shouldShowTag = shouldShowBestSellerTag(product)

  if (!shouldShowTag) {
    return null
  }

  const tagText = customText !== undefined ? customText : t('Popular')

  return (
    <Tag
      as="span"
      size="lg"
      className={`
        ${tagStyles.tag}
        ${styles['best-seller-tag']}
        ${className}
      `}
      aria-label={t('bestSellerAriaLabel')}
    >
      {tagText}
    </Tag>
  )
}

export default BestSellerTag
